export default [
  {name: 'Mr', gender: 'Male'},
  {name: 'Mrs', gender: 'Female'},
  {name: 'Ms', gender: 'Female'},
  {name: 'Miss', gender: 'Female'},
  {name: 'Dr', gender: null},
]